import { ProtectedJsonAPI } from '.'

export const MonthlyReports = ProtectedJsonAPI.extend(
  '/monthly_reports',
  {
    show:   endpoint => endpoint
  }
)
